import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-arrow-a",
  "use": "icon-ic-arrow-a-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-ic-arrow-a\"><path data-name=\"路径 2359\" d=\"M6.594 8.95a.732.732 0 01-.612.276c-.216.036-.42-.132-.588-.276l-5.2-5.22a.679.679 0 11.96-.96l4.84 4.97 4.848-4.968a.679.679 0 01.96.96l-5.208 5.22z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol